module.exports = __webpack_public_path__ + "static/media/bg.15b0fb59.png";